// components/Sidebar.js
import React from "react";
import {
  LayoutDashboard,
  Users,
  Building,
  MessageSquare,
  Settings,
  LogOut,
  ChevronLeft,
  ChevronRight,
  Upload,
  CheckCircle,
  User,
  FileText,
  GitBranch
} from "lucide-react";
import "../../styles/sidebar.css";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2"; // Import SweetAlert
import { logout } from "../../store/authSlice";
import { postWithTokenAPI } from "../../util/Api";
import TrueExamlogo from '../../assets/icon1.png'

const Sidebar = ({ activeMenuItem, onMenuClick, isCollapsed, toggleSidebar }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { token, roleType, userId } = useSelector((state) => state.auth);

  console.log(userId, 'userId')

  const handleLogout = () => {
    const Logoutpath = roleType === "superadmin" ? "/admin/login" : "/institutions/login"
    Swal.fire({
      title: "Are you sure?",
      text: "You will be logged out of your session!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#2563eb",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, logout!",
      padding: "2em",
      customClass: {
        popup: "my-swal-popup",
      },
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const payload = {
            userId: userId,
          };

          const res = await postWithTokenAPI(token, "/user/logout", payload);
          if (res?.statusCode === 200) {
            dispatch(logout());
            Swal.fire({
              toast: true,
              position: "top-end",
              icon: "success",
              title: "Logged out!",
              text: "You have been logged out.",
              showConfirmButton: false,
              timer: 1500,
              timerProgressBar: true,
            }).then(() => {
              navigate(Logoutpath);
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "Logout failed",
              text: res?.message || "Something went wrong",
            });
          }
        } catch (error) {
          console.error("Logout API error:", error);

          Swal.fire({
            icon: "error",
            title: "Logout failed",
            text: "Server error. Please try again.",
          });
        }
      }
    });
  };


  const menuItems =
    roleType === "superadmin"
      ? [
        {
          id: "Dashboard",
          icon: <LayoutDashboard size={20} />,
          label: "Dashboard",
          path: "/",
        },
        {
          id: "Students",
          icon: <Users size={20} />,
          label: "Students",
          path: "/students",
        },
        {
          id: "Institutions",
          icon: <Building size={20} />,
          label: "Institutions",
          path: "/institutions",
        },
        {
          id: "CMS",
          icon: <Settings size={20} />,
          label: "CMS",
          path: "/cms",
        },
        {
          id: "VersionControl",
          icon: <GitBranch size={20} />,
          label: "Version Control",
          path: "/version-control",
        },
        {
          id: "Message",
          icon: <MessageSquare size={20} />,
          label: "Message",
          path: "/message",
        },
      ]
      : [
        {
          id: "Dashboard",
          icon: <LayoutDashboard size={20} />,
          label: "Dashboard",
          path: "/institution/dashboard",
        },
        {
          id: "Upload",
          icon: <Upload size={20} />,
          label: "Upload",
          path: "/upload",
        },
        {
          id: "Approval",
          icon: <CheckCircle size={20} />,
          label: "Approval",
          path: "/approval",
        },
        {
          id: "Accounts",
          icon: <User size={20} />,
          label: "Accounts",
          path: "/accounts",
        },
        {
          id: "Legal",
          icon: <FileText size={20} />,
          label: "Legal",
          path: "/legal",
        },
        {
          id: "Message",
          icon: <MessageSquare size={20} />,
          label: "Message",
          path: "/message",
        },
      ];


  const bottomMenuItems = [
    { id: "Logout", icon: <LogOut size={20} />, label: "Logout", isLogout: true },
  ];

  const isActive = (path) => {
    if (path === "/") {
      return (
        location.pathname === "/" ||
        location.pathname.startsWith("/institution/dashboard") ||
        location.pathname.startsWith("/batches") ||
        location.pathname.startsWith("/omr")
      );
    }
    return location.pathname.startsWith(path);
  };
  return (
    <aside className={`sidebar ${isCollapsed ? 'collapsed' : ''}`}>
      {/* Logo Section */}
      <div className="sidebar-header">
        <div className="logo-container">
        <img src={TrueExamlogo} className="logo" alt="True Exam Logo" />

          {/* <h1 className="logo">TRUE EXAMS</h1> */}
        </div>

        <button className="sidebar-toggle-btn" onClick={toggleSidebar}>
          {isCollapsed ? <ChevronRight size={18} /> : <ChevronLeft size={18} />}
        </button>
      </div>

      {/* Main Navigation */}
      <nav className="main-menu">
        {menuItems.map((item) => (
          <button
            key={item.id}
            className={`menu-item ${roleType !== "superadmin" ? "menu-Institutions" : ""
              } ${isActive(item.path) ? "active" : ""}`}
            onClick={() => onMenuClick(item)}
          >
            <span className="menu-icon" >{item.icon}</span>
            {!isCollapsed && <span className="menu-label">{item.label}</span>}
            {isActive(item.path) && (
              <div className="active-left-bar"></div>
            )}
          </button>
        ))}
      </nav>

      <nav className="bottom-menu">
        {bottomMenuItems.map((item) => (
          <button
            key={item.id}
            className={`menu-item ${item.isLogout ? 'logout' : ''}`}
            onClick={() => {
              if (item.isLogout) {
                handleLogout();
              } else {
                onMenuClick(item);
              }
            }}
          >
            <span className="menu-icon">{item.icon}</span>
            {!isCollapsed && <span className="menu-label">{item.label}</span>}
            {activeMenuItem === item.id && (
              <div className="active-left-bar"></div>
            )}
          </button>
        ))}
      </nav>


    </aside>
  );
};

export default Sidebar;